import ApiService from "../../services/api";
import gridClientBase from "../../components/gridClientComponentBase";
import moment from "moment";
import { mapGetters } from "vuex";
import cellDeleteCommand from "../../components/grid/cellDeleteCommand/cellDeleteCommand.vue";

export default {
	extends: gridClientBase,
	data: () => {
		return {
			vehicleIdFilterField: "number_plate",
			isDriverDetailInEditMode: false,
			vehicles: [],
			driverId: 0,
			isNewDriver: false,

			groupsData: [],
			groupsSelected: [],

			id: 0,
			name: "",
			surname: "",
			email: "",
			fiscal_code: "",
			mobile_phone_number: "",
			employee_register: "",
			rfid_code: "",
			notes: "",
			is_dismissed: false,
			groups: [{ key: 0, value: "" }],
			savePendingRequest: null,
			saveVechilesDriversAssociationRequest: null,

			itemTemplate: "<div style='height: 50px'>#= number_plate # <br /><div style='font-size: 8px'> #= name # </div></div>",
			valueTemplate: "#= number_plate #",

			//table filters
			// vehicleNameFilters: [],
			// vehicleNameFilterSelected: [],
			plateNumberFilters: [],
			plateNumberFilterSelected: [],
			boxNumberFilters: [],
			boxNumberFilterSelected: []
		};
	},

	created() {
		var self = this;
		this.driverId = this.$route.params.id;
		this.vehicleIdFilterField = this.settings.vehicleIdFilterField;

		if (this.driverId == 0) {
			this.isNewDriver = true;
		}

		var newItem = {
			id: 0,
			name: "",
			number_plate: "",
			code: "",
			division_id: 0,
			fringebenefit: false,
			start_date: null,
			end_date: null,
			driver_id: this.driverId,
			vehicle_id: 0
		};
		this.defaultAddRow = newItem;
		this.sort = [{ field: "start_date", dir: "desc" }];

		if (this.isNewDriver) {
			this.isDriverDetailInEditMode = true;
		}

		this.getGroups().finally(() => {
			self.getData();
		});
		this.getAllVehicles();
	},

	methods: {
		isNumber: function(evt) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (charCode > 31 && (charCode < 48 || charCode > 57)) {
				evt.preventDefault();
			} else {
				return true;
			}
		},
		onVehicleChange(e, rowId) {
			var newValue = e.sender.value();

			var row = this.items.find(function(item) {
				return item.id === rowId;
			});

			var newVehicle = this.vehicles.find(item => {
				return item.id == newValue;
			});

			if (row) {
				row.name = newVehicle.name;
				row[this.vehicleIdFilterField] = newVehicle.number_plate;
				row.start_date = "";
				row.end_date = "";
				row.vehicle_id = newVehicle.id;
			}

			this.itemChange({
				dataItem: row
			});
		},
		getAllVehicles: function() {
			var self = this;
			ApiService.getVehiclesLookup({ page: 0, pageSize: 1000000 }, this.vehicleIdFilterField).then(res => {
				self.vehicles = res.items.map(function(vehicle) {
					return {
						id: vehicle.id,
						name: vehicle.name,
						number_plate: vehicle.number_plate ? vehicle.number_plate : "",
						name_numberplate: `${vehicle.number_plate} ${vehicle.name}`
					};
				});

				self.getVehiclesByDriverId();

				self.vehicles = self._.sortBy(self.vehicles, function(vc) {
					return vc.number_plate.toLowerCase();
				});

				for (var i = 0; i < self.vehicles.length; i++) {
					var vehicle = self.vehicles[i];
					// if (vehicle.name) {
					// 	var alreadyExist =
					// 		self.vehicleNameFilters.findIndex(item => {
					// 			return item.id == vehicle.name.toLowerCase();
					// 		}) >= 0;
					// 	if (!alreadyExist) {
					// 		self.vehicleNameFilters.push({
					// 			id: vehicle.name.toLowerCase(),
					// 			value: vehicle.name.toLowerCase()
					// 		});
					// 	}
					// }

					if (vehicle.number_plate) {
						var alreadyExist =
							self.plateNumberFilters.findIndex(item => {
								return item.id == vehicle.number_plate;
							}) >= 0;
						if (!alreadyExist) {
							self.plateNumberFilters.push({
								id: vehicle.number_plate,
								value: vehicle.number_plate
							});
						}
					}
				}
			});
		},
		getVehiclesByDriverId: function() {
			var self = this;
			var driverId = this.driverId;

			if (!this.isNewDriver) {
				ApiService.getVehiclesByDriverId(driverId).then(res => {
					if (self._.isNull(res) === false && self._.isUndefined(res) === false && self._.isArray(res) && res.length > 0) {
						self.items = res.map(function(item) {
							return {
								id: item.id,
								name: item.name,
								box_serial_number: item.box_serial_number,
								number_plate: item.number_plate,
								code: item.code ? item.code : "",
								division_id: item.division_id,
								fringebenefit: item.fringebenefit,
								start_date: item.start_date,
								end_date: item.end_date,
								driver_id: item.driver_id,
								vehicle_id: item.vehicle_id
								//groups: item.groups
							};
						});
					}

					for (var i = 0; i < self.items.length; i++) {
						var vehicle = self.items[i];
						if (vehicle.box_serial_number) {
							var alreadyExist =
								self.boxNumberFilters.findIndex(item => {
									return item.id == vehicle.box_serial_number;
								}) >= 0;
							if (!alreadyExist) {
								self.boxNumberFilters.push({
									id: vehicle.box_serial_number,
									value: vehicle.box_serial_number
								});
							}
						}
					}
				});
			}
		},
		getGroups: function() {
			var self = this;
			return new Promise(function(resolve, reject) {
				ApiService.getGroupsData()
					.then(res => {
						self.groupsData = res.map(function(item) {
							return {
								id: item.id,
								description: item.name ? item.name.toLowerCase() : ""
							};
						});

						self.groupsData = self._.sortBy(self.groupsData, ["description"]);
						resolve();
					})
					.catch(err => {
						reject();
					});
			});
		},
		getData() {
			var self = this;
			var idDriver = this.driverId;

			if (!this.isNewDriver) {
				ApiService.getDriverDetail(idDriver)
					.then(res => {
						if (self._.isNull(res.data) === false) {
							var data = res;

							self.id = data.id;
							self.name = data.name;
							self.surname = data.surname;
							self.email = data.email;
							self.fiscal_code = data.fiscal_code;
							self.mobile_phone_number = data.mobile_phone_number;
							self.employee_register = data.employee_register;
							self.rfid_code = data.rfid_code;
							self.notes = data.notes;
							self.is_dismissed = data.is_dismissed;

							self.groups = data.groups || [{ key: 0, value: "" }];

							self.groupsSelected = self._.sortBy(data.groups, function(it) {
								return it.value ? it.value.toLowerCase() : "";
							}).map(function(e) {
								return e.key;
							});
						}
					})
					.catch(err => {
						///TODO
					});
			}
		},
		groupsToString(groups) {
			if (this._.isNull(groups) === false && this._.isUndefined(groups) === false && this._.isArray(groups) && groups.length > 0) {
				var str = "";
				groups = this._.sortBy(groups, function(it) {
					return it.value ? it.value.toLowerCase() : "";
				});
				groups.forEach(element => {
					str += element.value + ", ";
				});

				str = str.replace(/, $/, "");
				return str;
			}

			return "";
		},
		switchDriverDetailEditMode() {
			this.isDriverDetailInEditMode = !this.isDriverDetailInEditMode;

			if (!this.isDriverDetailInEditMode) {
				this.getData();
			}

			this.savePendingRequest = null;
		},
		switchEditMode() {
			this.isInEditMode = !this.isInEditMode;

			if (!this.isInEditMode) {
				this.clearWorkingData();
				this.getVehiclesByDriverId();
			}

			this.saveVechilesDriversAssociationRequest = null;
		},
		saveDriverDetail() {
			var self = this;

			if (this.savePendingRequest == null) {
				this.savePendingRequest = ApiService.saveDriverDetail(
					this.id,
					this.name,
					this.surname,
					this.email,
					this.fiscal_code,
					this.mobile_phone_number,
					this.employee_register,
					this.rfid_code,
					this.is_dismissed,
					this.notes,
					this.groupsSelected
				)
					.then(res => {
						this.isDriverDetailInEditMode = false;

						var id = res.data;
						if (self.isNewDriver) {
							self.$router.push({
								name: "DRIVERS_DETAIL",
								params: {
									id: id
								}
							});
							self.driverId = id;
							self.isNewDriver = false;
							self.defaultAddRow.driver_id = id;
						}

						self.getData();
					})
					.catch(err => {})
					.finally(_ => {
						self.savePendingRequest = null;
					});
			}
		},
		saveVehiclesData() {
			var self = this;

			var createdItemsNormilized = [];
			for (let i = 0; i < this.createdItems.length; i++) {
				let item = this._.clone(this.createdItems[i]);

				if (item.start_date) {
					item.start_date = this.dateStringToMomentFormat(item.start_date);
				}

				if (item.end_date) {
					item.end_date = this.dateStringToMomentFormat(item.end_date);
				} else {
					item.end_date = null;
				}
				createdItemsNormilized.push(item);
			}

			var updatedItemsNormilized = [];
			for (let i = 0; i < this.updatedItems.length; i++) {
				let item = this._.clone(this.updatedItems[i]);

				if (item.start_date) {
					item.start_date = this.dateStringToMomentFormat(item.start_date);
				}

				if (item.end_date) {
					item.end_date = this.dateStringToMomentFormat(item.end_date);
				} else {
					item.end_date = null;
				}
				updatedItemsNormilized.push(item);
			}

			var deletedItemsNormilized = [];
			for (let i = 0; i < this.deletedItems.length; i++) {
				let item = this._.clone(this.deletedItems[i]);

				if (item.start_date) {
					item.start_date = this.dateStringToMomentFormat(item.start_date);
				}

				if (item.end_date) {
					item.end_date = this.dateStringToMomentFormat(item.end_date);
				} else {
					item.end_date = null;
				}
				deletedItemsNormilized.push(item);
			}

			this.saveVechilesDriversAssociationRequest = ApiService.saveDriversVehiclesAssociation(createdItemsNormilized, updatedItemsNormilized, deletedItemsNormilized)
				.then(res => {
					self.clearWorkingData();
					self.getVehiclesByDriverId();

					self.isDriverDetailInEditMode = false;
					self.getData();
				})
				.catch(err => {})
				.finally(_ => {
					self.saveVechilesDriversAssociationRequest = null;
				});
		},
		dateStringToMomentFormat(dateString) {
			if (dateString.indexOf("/") >= 0) {
				return moment(dateString, "DD/MM/YYYY").format();
			}

			return moment(dateString).format();
		},
		isColumnFilterable(field) {
			if (this.columns) {
				var c = this.columns.find(function(f) {
					return f.field == field;
				});

				if (c && c.filterable) {
					return true;
				}
			}

			return false;
		},
		isReadOnlyCell(field, item) {
			if (this.columns) {
				var c = this.columns.find(function(f) {
					return f.field == field;
				});

				if (item.id > 0 && ((c && c.readonly) || this._.isNull(item.box_serial_number) || this._.isUndefined(item.box_serial_number) || item.box_serial_number == "")) {
					return true;
				}
			}

			return false;
		}
	},

	computed: {
		...mapGetters(["settings"]),
		matriculationDateFormat() {
			return this.$options.filters.dateToString(this.matriculation_date);
		},
		groupsString() {
			return this.groupsToString(this.groups);
		},
		columns: function() {
			return [
				{
					field: this.vehicleIdFilterField == "code" ? "code" : "number_plate",
					title: this.vehicleIdFilterField == "code" ? "codice" : "targa",
					headerCell: "myVehicleNumberPlateHeaderTemplate",
					cell: "numberPlateCellTemplate",
					filterable: true
				},
				{
					field: "name",
					title: "nome",
					headerCell: "myHeaderTemplate",
					filterable: true,
					cell: "nameCellTemplate"
				},
				{
					field: "box_serial_number",
					title: "box",
					headerCell: "myBoxHeaderTemplate",
					filterable: true
				},
				{
					field: "fringebenefit",
					title: "fringebenefit",
					width: "140",
					format: "boolean",
					className: "text-center",
					headerCell: "myBooleanHeaderTemplate",
					cell: "myCellTemplate",
					readonly: true,
					filterable: true
				},
				{
					field: "start_date",
					title: "Data Inizio",
					format: "date",
					headerCell: "myDateHeaderTemplate",
					cell: "myCellTemplate",
					filterable: true
				},
				{
					field: "end_date",
					title: "Data Fine",
					format: "date",
					headerCell: "myDateHeaderTemplate",
					cell: "myCellTemplateNotRequired",
					filterable: true
				},
				{
					cell: "myCellDeleteTemplate",
					width: "45px",
					sortable: false,
					headerCell: "myHeaderTemplate"
				}
			];
		}
	}
};
